
import Vue from "vue";
import loadingComponent from '@/components/loading.vue'
const LoadingConstructor = Vue.extend(loadingComponent)
let toastDom, el;
export const showLoading = function ({ title, type, duration = 2000 }) {
    if (!el && !toastDom) {
        el = document.createElement('div');
        toastDom = new LoadingConstructor({
            el,
            data() {
                return {
                    isShow: true, // 是否显示
                    title // 文本内容
                };
            }
        });
        // 添加节点
        document.body.appendChild(toastDom.$el);
    } else {
        toastDom.isShow = true;
    }
}

export const cancelLoading = function () {
    if (toastDom) {
        toastDom.isShow = false;
    }
}






// WEBPACK FOOTER //
// ./src/modules/js/loadingIndex2.js